import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Department, SiteCodes } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-setup-dep',
  templateUrl: './edit-setup-dep.component.html',
  styleUrls: ['./edit-setup-dep.component.css']
})
export class EditSetupDepComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<EditSetupDepComponent>,
    private _safetyConfigService:SafetyConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  selectedName:string="";
  selectedDescription:string="";
  departmentlist:Department[]=[]
  siteCodesList: SiteCodes[]=[];
  inputValuestate:number
  inputValueSefetyObservation:number
  ngOnInit() {
    this.getdepartmentlist();
    this.loadSiteList();
  }
  
  state = new FormControl("", [Validators.required]);
  sefetyobservation = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }
  getObservationErrorMessage() {
    return this.sefetyobservation.hasError("required") ? "You must select a value" : "";
  }
  loadSiteList()
  {
    this._safetyConfigService.getAllSitesList().subscribe(sites =>
    { 
      console.log('sitelist',sites)
      this.siteCodesList=sites;
      
    });
  }
  DialogClose(){
    this.dialogRef.close(false)
  }

  UpdateDepartment(){
    if(this.inputValueSefetyObservation == undefined || this.selectedName==undefined || this.inputValueSefetyObservation <=0 || this.selectedName=="" || this.inputValuestate ==undefined){
      return;  
      }else{
        let model= new Department()
        model.DepartmentName=this.selectedName;
        model.DepartmentDescription=this.selectedDescription
        model.ID=this.data.catId
        model.SiteId=this.inputValuestate
        model.ObservationTypeId=this.inputValueSefetyObservation
        console.log('input values',model)
        this._safetyConfigService.UpdateDepartment(model).subscribe(res =>{
     
      if(res.m_Item1=true){
        console.log('result', res)
        this.DialogClose();
       
      }
      
    })
      }
      
}


 getdepartmentlist(){
  this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
  this.departmentlist=res.Departments;
  
  console.log( "departments",this.departmentlist)

  this.departmentlist.map(x=>{
    if(x.ID==this.data.catId)
    {
      this.selectedName=x.DepartmentName
      this.selectedDescription=x.DepartmentDescription
      this.inputValuestate=x.SiteId
      this.inputValueSefetyObservation=x.ObservationTypeId
      console.log( "after",this.selectedName)
    }
  })  
  })
}

}


